"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("highchartUtils", function () {
  var utils = {};
  utils.copyChartOptions = function (chart) {
    var options = chart._originalOptions || chart.options;
    var renderTo = options.chart.renderTo;
    options.chart.renderTo = null;
    var optionsCopy = angular.copy(options);
    options.chart.renderTo = renderTo;
    return optionsCopy;
  };
  utils.copyChartSeries = function (chart) {
    return angular.copy(_.map(chart.series, function (serie) {
      var serieOptions = serie.options;
      if (!serieOptions.color) {
        serieOptions.color = serie.color;
      }
      serieOptions.animation = false;
      return serieOptions;
    }));
  };
  utils.copyChartConfigForPopins = function (chart) {
    var options = utils.copyChartOptions(chart);
    var series = utils.copyChartSeries(chart);

    // options override
    options.exporting.enabled = false;

    // disable animation on init
    options.chart.animation = false;
    options.plotOptions.series.animation = false;

    // force xAxis & yAxis to be lists to make it easier to work with later
    if (options.xAxis && !_.isArray(options.xAxis)) {
      options.xAxis = [options.xAxis];
    }
    if (options.yAxis && !_.isArray(options.yAxis)) {
      options.yAxis = [options.yAxis];
    }
    return {
      options: options,
      series: series
    };
  };
  return utils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/highcharts-utils.js
// module id = 2965
// module chunks = 13